<div #socialNav class="card flex flex-column align-items-center p-0 m-0">
  <div class="grid width-100">
    <div class="col-12 p-0 nav-swiper" *ngIf="hasSlides()">
      <swiper
        #mainSwiper
        [config]="config"
        (swiper)="onMainSwiperReady($event)"
        [slideActiveClass]="'active'"
        [watchOverflow]="true"
        [updateOnImagesReady]="true"
        [autoHeight]="true"
        [lazy]="true"
      >
        <ng-template swiperSlide *ngFor="let item of slides|keyvalue: originalOrder; let last = last; let i = index">
          <div class="flex justify-content-center align-self-stretch px-3" (click)="setActiveSlaveSlide(i, item.value, slaveSwiper, $event)">
            <div class="flex align-items-center justify-content-center gap-2">
              <span>{{ item.value.label | translate }}</span>
              <span
                class="font-bold blue-color"
              >
                      {{ item.value.count }}
                </span>
            </div>
          </div>
        </ng-template>
      </swiper>
    </div>
  </div>
</div>
<div class="grid grid-nogutter width-100 mb-2">
  <div class="col-12 p-0 my-2" *ngIf="hasSlides()">
    <swiper
      #slaveSwiper
      [class.social-grid-content-swiper--fill]="fillAvailableHeight"
      [config]="childConfig"
      (swiper)="onChildSwiperReady($event)"
      (activeIndexChange)="setActiveSlide($event)"
      (dragstart)="handOffEdgeSwipes && $event.preventDefault()"
      [updateOnImagesReady]="true"
      [updateOnWindowResize]="true"
      [observeSlideChildren]="true"
      [lazy]="true"
      [preloadImages]="true"
      [autoHeight]="true"
      [watchOverflow]="true"
      >
        <ng-template swiperSlide *ngFor="let slide of slides|keyvalue: originalOrder; let last = last; let i = index">
          <app-social-timeline
            *ngIf="isCollectionContextReady()"
            [slide]="slide"
            [noResultsMsg]="('common.no_' + listType + '.' + slide.key)|lowercase|translate"
          >
          </app-social-timeline>
        </ng-template>
      </swiper>
  </div>
</div>

